import React from "react";
import ReactDOM from "react-dom";
import App from "./components/App";
import "./assets/fonts.css";

ReactDOM.render(
    <React.StrictMode>
        <App />
    </React.StrictMode>,
    document.getElementById("root")
);
